import BillingHTTP from 'utils/billing-http';

class PixService {
  getPixBillPayment(billingId, billId) {
    const route = `/dashboard-api/v2/billings/${billingId}/bills/${billId}/bill-payments/pix-bill-payment`;

    return BillingHTTP.getContent(route);
  }

  createPixBillPayment(billingId, billId) {
    const route = `/dashboard-api/v2/billings/${billingId}/bills/${billId}/bill-payments`;
    const params = { payment_method: 'pix' };

    return BillingHTTP.postContent(route, params);
  }
}

export default new PixService();
